import { useQuery } from 'react-query';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import { Doc } from '../types/backend-dto-types';
import useGetFetchConfig from '../useGetFetchConfig';

export const useGetDoc = (caseId: string | null, docId: string | null, includeSurroundingDocIds = false) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<Doc>(
    [QueryEntity.Doc, { docId, includeSurroundingDocIds }],
    () => {
      return fetch(
        `${APIBaseChronos}/api/case/${caseId}/docs/${docId}?includeSurroundingDocIds=${includeSurroundingDocIds}`,
        fetchConfigGET,
      ).then((res) => {
        return res.json();
      });
    },
    {
      enabled: !!caseId && !!docId,
      refetchOnWindowFocus: false,
    },
  );
};
